import axios from 'axios'
import { getToken, getAppVersion, getAppVersionCode, getAppPackage, getAppStoreName } from '@/utils/auth'
import { showLoadingToast, showDialog, closeToast } from 'vant'
import appJS from '@/utils/appJS'
import store from '@/store'
// 用于取消上次请求
const { isCancel } = axios
const cacheRequest = {}
const abortCacheRequest = (reqKey) => {
  if (cacheRequest[reqKey]) {
    // 通过AbortController实例上的abort来终止请求
    cacheRequest[reqKey].abort()
    delete cacheRequest[reqKey]
  }
}
// 是否显示重新登录
export let isRelogin = { show: false }

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_APP_BASE_API,
  // 超时
  timeout: 30000
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    const { url, method, isAbort = false } = config
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // 取消上次请求
    if (isAbort) {
      // 请求地址和请求方式组成唯一标识，将这个标识作为取消函数的key，保存到请求队列中
      const reqKey = `${url}&${method}`
      // 如果config传了需要清除重复请求的isAbort，则如果存在重复请求，删除之前的请求
      abortCacheRequest(reqKey)
      // 将请求加入请求队列，通过AbortController来进行手动取消
      const controller = new AbortController()
      config.signal = controller.signal
      cacheRequest[reqKey] = controller
    }
    if (getToken() && !isToken) {
      config.headers['appToken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    config.headers['APPOS'] = isAndroid ? 'ANDROID' : 'IOS' // 当前请求系统
    config.headers['APPVERSION'] = getAppVersion()
    if (getAppPackage()) {
      // 包名
      config.headers['APPPACKAGENAME'] = getAppPackage()
    }
    // 上送版本号
    // if (import.meta.env.MODE !== 'development') {
      config.headers['APPVERSIONNUMBER'] = getAppVersionCode()
    // }
    config.headers['appStoreName'] = getAppStoreName()
    if (config.loading) {
      showLoadingToast({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
    }
    return config
  },
  (error) => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 去掉上次请求
    const { url, method, isAbort = false } = res.config
    if (isAbort) delete cacheRequest[`${url}&${method}`]
    if (res.config.loading) {
      closeToast() // 清除加载中
    }
    const code = res.data.rspCode
    const msg = res.data.rspMsg
    // 获取错误信息
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code === '0000') {
      return Promise.resolve(res.data)
    } else if (code === '0005' || code === '0004') {
      if (res.config.skipAuthRedirect) {
        return Promise.reject(res.data)
      }
      store.dispatch('FedLogOut').then(() => {
        appJS.appLogin()
      })
      return Promise.reject('error')
    } else {
      showDialog({
        message: msg ? msg : '请求失败'
      }).then(() => {
        // on close
      })
      return Promise.reject(msg)
    }
  },
  (error) => {
    closeToast() // 清除加载中
    if (isCancel(error)) {
      // 通过AbortController取消的请求不做任何处理
      return Promise.reject({
        message: '重复请求，已取消'
      })
    }
    console.log('error', error)
    let { message } = error
    if (message == 'Network Error') {
      message = '网络连接异常，请重新打开APP'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    showDialog({
      message: message ? message : '登录失效，请重新登录'
    }).then(() => {
      // on close
    })
    return Promise.reject(error)
  }
)
export default service
